/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Redirect, Switch, Route} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {PrivateRoutes} from './PrivateRoutes'
import {Logout, AuthPage, selectUser} from '../modules/auth'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {MasterInit} from '../../_metronic/layout/MasterInit'
import {useAppSelector} from '../../setup/redux/hooks'
import {BankTransferRequest} from '../pages/bankTransferRequest/bankTransferRequest'
import {USER_STATUS} from '../shared/constants'

const Routes: FC = () => {
  const user = useAppSelector(selectUser)
  return (
    <>
      <Switch>
        {!user ? (
          /*Render auth page when user at `/auth` and not authorized.*/
          <Route>
            <AuthPage />
          </Route>
        ) : (
          /*Otherwise redirect to root page (`/`)*/

          <Redirect from='/auth' to={'/'} />
        )}

        <Route path='/error' component={ErrorsPage} />
        <Route path='/logout' component={Logout} />
        <Route exact path='/bank_transfer_request' component={BankTransferRequest} />
        {user?.status === USER_STATUS.ACTIVE && (
          <MasterLayout>
            <PrivateRoutes user={user}/>
          </MasterLayout>
        )}
      </Switch>
      <MasterInit />
    </>
  )
}

export {Routes}
